import React from 'react';

const HTMLField = ({ style, ...props}) => (
    <div style={{ ...style, textIndent: 20 }} dangerouslySetInnerHTML={{__html: props.value}} />
)

export default HTMLField;
